function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Space, Select, Drawer, Descriptions, Input, Dropdown, Form, Modal, notification, DatePicker, Alert, Tag } from 'antd';
import { Table } from 'react-bootstrap';
import { DownOutlined } from '@ant-design/icons';
import { PencilSquare, HourglassSplit, HourglassBottom, BoxArrowUpRight, EyeFill, Upload, ListCheck, PieChartFill, CheckSquareFill, PrinterFill, SendCheckFill, ForwardFill, SendCheck, CheckCircleFill, ClockHistory, ArrowLeftSquareFill } from "react-bootstrap-icons";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Common from "../components/includes/Common";
import Moment from "react-moment";
import AddConclusion from "../components/forms/AddConclusion";
import Certificate from "../components/Certificate";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import EditConclusion from "../components/forms/EditConclusion";
import MedicalReport from "../components/MedicalReport";
import CompleteRecord from "../components/CompleteRecord";
import SendList from "../components/SendList";
import SendReport from "../components/SendReport";
import RefDocument from "../components/RefDocument";
import CertificateOld from "../components/CertificateOld";
import RecordHistory from "../components/RecordHistory";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var confirm = Modal.confirm;
var Conclusion = function Conclusion() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compList = _useState4[0],
    setCompList = _useState4[1];
  var _useState5 = useState([{
      value: 0,
      label: "TOUTES"
    }]),
    _useState6 = _slicedToArray(_useState5, 2),
    compOptions = _useState6[0],
    setCompOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyId = _useState8[0],
    setCompanyId = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    company = _useState0[0],
    setCompany = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    customers = _useState10[0],
    setCustomers = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentCustomer = _useState12[0],
    setCurrentCustomer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showAddConclusion = _useState14[0],
    setShowAddConclusion = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showCertificate = _useState16[0],
    setShowCertificate = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showEditConclusion = _useState18[0],
    setShowEditConclusion = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    dataChanged = _useState20[0],
    setDataChanged = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showEditData = _useState22[0],
    setShowEditData = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showDisplayData = _useState24[0],
    setShowDisplayData = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showUpload = _useState26[0],
    setShowUpload = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    file = _useState28[0],
    setFile = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showMreport = _useState30[0],
    setShowMreport = _useState30[1];
  var _useState31 = useState(""),
    _useState32 = _slicedToArray(_useState31, 2),
    fileErrorMessage = _useState32[0],
    setFileErrorMessage = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isFileFormProcessing = _useState34[0],
    setIsFileFormProcessing = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    conclusionLoading = _useState36[0],
    setConclusionLoading = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    lateRecords = _useState38[0],
    setLateRecords = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    showLateFiles = _useState40[0],
    setShowLateFiles = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    mailSendLoading = _useState42[0],
    setMailSendLoading = _useState42[1];
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    printLoading = _useState44[0],
    setPrintLoading = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    validateLoading = _useState46[0],
    setValidateLoading = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    uploading = _useState48[0],
    setUploading = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    showRefReport = _useState50[0],
    setShowRefReport = _useState50[1];
  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showVisitHistory = _useState52[0],
    setShowVisitHistory = _useState52[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var ref = useRef();
  var _useState53 = useState(20),
    _useState54 = _slicedToArray(_useState53, 2),
    limit = _useState54[0],
    setLimit = _useState54[1];
  var _useState55 = useState(0),
    _useState56 = _slicedToArray(_useState55, 2),
    offset = _useState56[0],
    setOffset = _useState56[1];
  var _useState57 = useState("0"),
    _useState58 = _slicedToArray(_useState57, 2),
    keyword = _useState58[0],
    setKeyword = _useState58[1];
  var _useState59 = useState(false),
    _useState60 = _slicedToArray(_useState59, 2),
    showSign = _useState60[0],
    setShowSign = _useState60[1];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var handleSendDocument = function handleSendDocument(c) {
    setMailSendLoading(true);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        style: {
          color: "#733F35"
        },
        children: "Confirmez-vous ? "
      }),
      content: /*#__PURE__*/_jsxs("b", {
        children: ["L'envoie du document au mail ", c.company.email, " ?"]
      }),
      onOk: function onOk() {
        shareCert(c);
      },
      onCancel: function onCancel() {
        setMailSendLoading(false);
      }
    });
  };
  var shareCert = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(c) {
      var fd;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            fd = new FormData(); //fd.append("cert_file", out); 
            fd.append("customer_id", c.id.toString());
            fd.append("user_id", Common.currentUser.id);
            axios.post(Common.baseApiUrl + "sharecertificate", fd).then(function (response) {
              if (response.data.status == 200) {
                notification.success({
                  message: "Ok!",
                  description: response.data.message
                });
              } else {
                notification.error({
                  message: "Erreur !",
                  description: response.data.message
                });
              }
            })["catch"](function (error) {
              notification.error({
                message: "Erreur !",
                description: "Une erreur est survenue " + error.toString()
              });
            })["finally"](function () {
              setMailSendLoading(false);
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function shareCert(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var savePdf = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(c) {
      var element, canvas, data, pdf, imgProperties, pdfWidth, pdfHeight, out, fd;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            element = ref.current;
            _context2.n = 1;
            return html2canvas(element);
          case 1:
            canvas = _context2.v;
            data = canvas.toDataURL('image/png');
            pdf = new jsPDF();
            imgProperties = pdf.getImageProperties(data);
            pdfWidth = pdf.internal.pageSize.getWidth();
            pdfHeight = imgProperties.height * pdfWidth / imgProperties.width;
            pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight, '', 'FAST');
            //pdf.save("CERT");
            //return;
            out = pdf.output('datauristring');
            fd = new FormData();
            fd.append("cert_file", out);
            fd.append("customer_id", c.id.toString());
            fd.append("user_id", Common.currentUser.id);
            axios.post(Common.baseApiUrl + "savecertificate", fd).then(function (response) {
              if (response.data.status == 200) {
                notification.success({
                  message: "Ok!",
                  description: response.data.message
                });
              } else {
                notification.error({
                  message: "Erreur !",
                  description: response.data.message
                });
              }
            })["catch"](function (error) {
              notification.error({
                message: "Erreur !",
                description: "Une erreur est survenue " + error.toString()
              });
            })["finally"](function () {
              setMailSendLoading(false);
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function savePdf(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var saveCertificate = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(c) {
      var element, canvas, data, pdf, imgProperties, pdfWidth, pdfHeight, out, fd;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            setUploading(true);
            element = ref.current;
            _context3.n = 1;
            return html2canvas(element);
          case 1:
            canvas = _context3.v;
            data = canvas.toDataURL('image/png');
            pdf = new jsPDF();
            imgProperties = pdf.getImageProperties(data);
            pdfWidth = pdf.internal.pageSize.getWidth();
            pdfHeight = imgProperties.height * pdfWidth / imgProperties.width;
            pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight, '', 'FAST');
            out = pdf.output('datauristring');
            fd = new FormData();
            fd.append("cert_file", out);
            fd.append("customer_id", c.id.toString());
            fd.append("user_id", Common.currentUser.id);
            axios.post(Common.baseApiUrl + "savecertificate", fd).then(function (response) {
              if (response.data.status == 200) {
                notification.success({
                  message: "Ok!",
                  description: response.data.message
                });
                setDataChanged(true);
              } else {
                notification.error({
                  message: "Erreur !",
                  description: response.data.message
                });
              }
            })["catch"](function (error) {
              notification.error({
                message: "Erreur !",
                description: "Une erreur est survenue " + error.toString()
              });
            })["finally"](function () {
              setIsDataLoading(false);
              setUploading(false);
            });
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function saveCertificate(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleKewordChange = function handleKewordChange(v) {
    setKeyword(v.target.value);
  };
  var handleMore = function handleMore() {
    setLimit(function (prev) {
      return prev + 20;
    });
  };
  var handleValidate = function handleValidate(c) {
    setValidateLoading(true);
    setCurrentCustomer(c);
    confirm({
      title: /*#__PURE__*/_jsx("p", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        style: {
          color: '#9C6A5C'
        },
        children: ["La fermeture la validation du dossier ", c.candidate_code, " pour le patient ", c.name]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "terminateprocess", {
          user_id: Common.currentUser.id,
          customer_id: c.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            setShowCertificate(false);
            notification.success({
              message: "Ok!",
              description: "Dossier validé avec succès"
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {
          setValidateLoading(false);
        });
      }
    });
  };
  var handleForward = function handleForward(c) {
    setCurrentCustomer(c);
    confirm({
      title: /*#__PURE__*/_jsx("p", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        style: {
          color: '#9C6A5C'
        },
        children: ["Referer le dossier ", c.candidate_code, " pour le patient ", c.name]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "forwardprocess", {
          user_id: Common.currentUser.id,
          customer_id: c.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Dossier validé avec succès"
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleReturn = function handleReturn(c) {
    setCurrentCustomer(c);
    confirm({
      title: /*#__PURE__*/_jsx("p", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        style: {
          color: '#9C6A5C'
        },
        children: ["La reouverture du dossier ", c.candidate_code, " pour le patient ", c.name]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "unterminateprocess", {
          user_id: Common.currentUser.id,
          customer_id: c.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Reouvert avec succès"
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleCompanyChange = function handleCompanyChange(v) {
    if (compList.filter(function (c) {
      return c.id == v;
    }).length > 0) {
      setCompany(compList.filter(function (c) {
        return c.id == v;
      })[0]);
      setCompanyId(compList.filter(function (c) {
        return c.id == v;
      })[0].id);
      localStorage.setItem("defaultCompany", compList.filter(function (c) {
        return c.id == v;
      })[0].id);
    } else {
      setCompany(null);
      setCompanyId(0);
      localStorage.setItem("defaultCompany", 0);
    }
  };
  var items = [{
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(HourglassSplit, {
        size: 21
      })
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date V."
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "TYPE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "AGENT"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion == null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: c.created_at,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.category != "0" && c.category
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.user.firstname + " " + c.user.lastname
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RECAP."
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowAddConclusion(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONCLURE"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    icon: /*#__PURE__*/_jsx(ClockHistory, {}),
                    type: "primary",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowVisitHistory(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Hist. Visites"
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(CheckCircleFill, {
        size: 21
      })
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "DATE V."
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "AGENT"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 0;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              style: {
                color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
              },
              children: [/*#__PURE__*/_jsx("td", {
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: c.created_at,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.user.firstname + " " + c.user.lastname
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RECAP."
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowCertificate(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CERTIF."
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowMreport(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "R. MEDICAL"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "middle",
                    disabled: Common.currentUser.role != 31 && Common.currentUser.role != 901,
                    onClick: function onClick() {
                      handleValidate(c);
                    },
                    style: {
                      background: "#67A275"
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(CheckCircleFill, {
                        size: 22
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEditConclusion(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(PencilSquare, {
                        size: 22
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 22
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    icon: /*#__PURE__*/_jsx(ClockHistory, {}),
                    type: "primary",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowVisitHistory(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Hist. Visites"
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(SendCheck, {
        size: 24
      })
    }),
    key: 3,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {
              children: "DATE V."
            }), /*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "AGENT"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 1;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: c.conclusion.file != null ? /*#__PURE__*/_jsx("div", {
                  style: {
                    padding: "5px",
                    width: "5px",
                    borderRadius: "5px",
                    background: "#963F35"
                  }
                }) : /*#__PURE__*/_jsx("div", {
                  style: {
                    padding: "5px",
                    width: "5px",
                    borderRadius: "5px",
                    background: "#359695"
                  }
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: c.created_at,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsx(Dropdown, {
                  menu: {
                    items: [{
                      label: /*#__PURE__*/_jsx("span", {
                        children: "RH : " + c.company.email
                      }),
                      key: "m1"
                    }, {
                      label: /*#__PURE__*/_jsx("span", {
                        children: "Facturation :" + c.company.email_1
                      }),
                      key: "m2"
                    }, {
                      label: /*#__PURE__*/_jsx("span", {
                        children: "Commercial :" + c.company.email_2
                      }),
                      key: "m3"
                    }]
                  },
                  children: /*#__PURE__*/_jsx("a", {
                    onClick: function onClick(e) {
                      return e.preventDefault();
                    },
                    children: /*#__PURE__*/_jsxs(Space, {
                      children: [c.company.label, " ", /*#__PURE__*/_jsx(DownOutlined, {})]
                    })
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.user.firstname + " " + c.user.lastname
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RECAP."
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowCertificate(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CERTIFICAT"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowMreport(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "R. MEDICAL"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 24
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "middle",
                    disabled: Common.currentUser.role != 31 && Common.currentUser.role != 901,
                    onClick: function onClick() {
                      handleReturn(c);
                    },
                    style: {
                      background: "#E19E52"
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(ArrowLeftSquareFill, {
                        size: 22
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    icon: /*#__PURE__*/_jsx(ClockHistory, {}),
                    type: "primary",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowVisitHistory(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Hist. Visites"
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(ForwardFill, {
        size: 24
      })
    }),
    key: 4,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "DATE V."
            }), /*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "AGENT"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 2;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: c.created_at,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsx(Dropdown, {
                  menu: {
                    items: [{
                      label: /*#__PURE__*/_jsx("span", {
                        children: "RH : " + c.company.email
                      }),
                      key: "mr1"
                    }, {
                      label: /*#__PURE__*/_jsx("span", {
                        children: "Facturation :" + c.company.email_1
                      }),
                      key: "mr2"
                    }, {
                      label: /*#__PURE__*/_jsx("span", {
                        children: "Commercial :" + c.company.email_2
                      }),
                      key: "mr3"
                    }]
                  },
                  children: /*#__PURE__*/_jsx("a", {
                    onClick: function onClick(e) {
                      return e.preventDefault();
                    },
                    children: /*#__PURE__*/_jsxs(Space, {
                      children: [c.company.label, " ", /*#__PURE__*/_jsx(DownOutlined, {})]
                    })
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: c.user.firstname + " " + c.user.lastname
              }), /*#__PURE__*/_jsx("td", {
                style: {
                  color: c.nationality.toLowerCase().indexOf("guin") > -1 && c.nationality.split(" ").length == 1 ? '#000000' : '#965435'
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RECAP."
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowMreport(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "R. MEDICAL"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEditConclusion(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(PencilSquare, {
                        size: 24
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowRefReport(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 24
                      })
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    key: 6,
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(PieChartFill, {
        size: 22
      })
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(SendReport, {
        companies: compOptions
      })
    })
  }];
  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    setDataChanged(false);
    if (cid == null) return;
    axios.post("".concat(Common.baseApiUrl, "getconclusioncustomers"), {
      company_id: cid,
      user_id: Common.currentUser.id,
      limit: limit,
      offset: offset,
      keyword: keyword
    }).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([{
          value: 0,
          label: "TOUTES"
        }]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        //setCompanyId(response.data.companyList[0].id);     
        setCompanyId(0);
        //setCompany(response.data.companyList[0]);
        setCompany(null);
        //loadData(response.data.companyList[0].id);        
        if (response.data.companyList.length > 0) {
          if (localStorage.getItem("defaultCompany") != null && localStorage.getItem("defaultCompany") != 'undefined') {
            form.setFieldsValue({
              comp: parseInt(localStorage.getItem("defaultCompany"))
            });
          } else {
            form.setFieldsValue({
              comp: response.data.companyList[0].id
            });
            localStorage.setItem("defaultCompany", response.data.companyList[0].id);
          }
        }
        loadData(localStorage.getItem("defaultCompany"));
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getlaterecords/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setLateRecords(response.data.records);
      }
    })["catch"](function (error) {
      alert("error " + error.toString());
    });
  }, []);
  useEffect(function () {
    loadData(companyId);
  }, [companyId, dataChanged, limit, keyword, offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#CONCLUSION DU MEDECIN"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "comp",
                children: /*#__PURE__*/_jsx(Select, {
                  showSearch: true,
                  optionLabelProp: "label",
                  optionFilterProp: "label",
                  filterOption: function filterOption(input, option) {
                    return option.label.toLowerCase().includes(input.toLowerCase());
                  },
                  options: compOptions,
                  onChange: handleCompanyChange,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Input, {
                  onChange: handleKewordChange,
                  placeholder: "Code dossier"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  banner: true,
                  type: "error",
                  message: /*#__PURE__*/_jsxs("b", {
                    children: ["Dossiers en retard ", lateRecords.length, " ... "]
                  }),
                  action: /*#__PURE__*/_jsxs(Button, {
                    size: "small",
                    onClick: function onClick() {
                      setShowLateFiles(true);
                    },
                    type: "text",
                    children: [" ", /*#__PURE__*/_jsx("b", {
                      children: " PARCOURIR"
                    })]
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Tabs, {
            destroyInactiveTabPane: true,
            items: items,
            tabPlacement: "start",
            animated: true,
            defaultActiveKey: 1
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx(Button, {
              loading: isDataLoading,
              type: "default",
              onClick: handleMore,
              children: /*#__PURE__*/_jsx("b", {
                children: "VOIR PLUS"
              })
            })
          })]
        })
      })]
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showAddConclusion,
        title: /*#__PURE__*/_jsx("b", {
          children: "CONCLUSION"
        }),
        width: "90%",
        centered: true,
        onClose: function onClose() {
          setShowAddConclusion(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(AddConclusion, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowAddConclusion(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showDisplayData,
        title: /*#__PURE__*/_jsxs("b", {
          children: ["DOSSIER DU CANDIDAT ", currentCustomer.link != null && currentCustomer.link.length > 4 && /*#__PURE__*/_jsx(Tag, {
            icon: /*#__PURE__*/_jsx(BoxArrowUpRight, {}),
            children: /*#__PURE__*/_jsx("a", {
              href: currentCustomer.link,
              target: "_blank",
              children: "dossier externe"
            })
          })]
        }),
        width: "90%",
        centered: true,
        onClose: function onClose() {
          setShowDisplayData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(CompleteRecord, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowAddConclusion(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })
      }), /*#__PURE__*/_jsxs(Drawer, {
        open: showCertificate,
        title: /*#__PURE__*/_jsx("b", {
          children: "CERTIFICAT D'APTITUDE"
        }),
        width: "90%",
        onClose: function onClose() {
          setShowCertificate(false);
          setMailSendLoading(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref4) {
              var handlePrint = _ref4.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                loading: printLoading,
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          size: "middle",
          loading: uploading,
          disabled: Common.currentUser.role != 31 && Common.currentUser.role != 901,
          onClick: function onClick() {
            saveCertificate(currentCustomer);
          },
          style: {
            background: "#A25959",
            marginLeft: "10px"
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(Upload, {
              size: 22
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: currentCustomer.status != 1,
          loading: mailSendLoading,
          type: "primary",
          style: {
            background: "#45736A",
            marginLeft: "10px"
          },
          onClick: function onClick() {
            handleSendDocument(currentCustomer);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(SendCheckFill, {
              size: 18
            }), "ENVOYER"]
          })
        })],
        destroyOnClose: true,
        children: [currentCustomer.conclusion && currentCustomer.conclusion.last_send_at != null && /*#__PURE__*/_jsxs(Tag, {
          color: "#2B6864",
          children: ["Derni\xE8re envoie le ", /*#__PURE__*/_jsx(Moment, {
            format: "DD/MM/YYYY H:mm",
            date: currentCustomer.conclusion.last_send_at
          })]
        }), /*#__PURE__*/_jsx("br", {}), currentCustomer.company_id != 151 ? /*#__PURE__*/_jsx(Certificate, {
          showSign: showSign,
          ref: ref,
          id: "cert-content",
          candidat: currentCustomer
        }) : /*#__PURE__*/_jsx(CertificateOld, {
          showSign: showSign,
          ref: ref,
          id: "cert-content",
          candidat: currentCustomer
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showMreport,
        title: /*#__PURE__*/_jsx("b", {
          children: "RAPPORT MEDICALE"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowMreport(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref5) {
              var handlePrint = _ref5.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          style: {
            background: "#45736A",
            marginLeft: "10px"
          },
          onClick: null,
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(SendCheckFill, {
              size: 18
            }), "ENVOYER"]
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(MedicalReport, {
          ref: ref,
          candidat: currentCustomer
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showRefReport,
        title: /*#__PURE__*/_jsx("b", {
          children: "FICHE REFERENCES"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowRefReport(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref6) {
              var handlePrint = _ref6.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(RefDocument, {
          ref: ref,
          candidat: currentCustomer
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showEditConclusion,
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LA CONCLUSION"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowEditConclusion(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditConclusion, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowEditConclusion(false);
            notification.success({
              message: "Ok!",
              description: "Modifications enregistrées"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showVisitHistory,
        title: /*#__PURE__*/_jsx("b", {
          children: "HISTORIQUE VISITES"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowVisitHistory(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(RecordHistory, {
          candidate: currentCustomer
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DOSSIERS DE PLUS DE 6 JOURS AVEC CERTIFICATS INTROUVABLES"
        }),
        width: "90%",
        destroyOnClose: true,
        open: showLateFiles,
        onClose: function onClose() {
          setShowLateFiles(false);
        },
        children: /*#__PURE__*/_jsxs(Table, {
          striped: true,
          bordered: true,
          hover: true,
          responsive: true,
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("th", {
                children: "Date"
              }), /*#__PURE__*/_jsx("th", {
                children: "CODE"
              }), /*#__PURE__*/_jsx("th", {
                children: "NOM"
              }), /*#__PURE__*/_jsx("th", {
                children: "POSTE"
              }), /*#__PURE__*/_jsx("th", {
                children: "CONTACT"
              }), /*#__PURE__*/_jsx("th", {
                children: "SOCIETE"
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: lateRecords.map(function (c) {
              return /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: c.created_at,
                      format: "DD/MM/YYYY"
                    })
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.candidate_code
                }), /*#__PURE__*/_jsx("td", {
                  children: c.name
                }), /*#__PURE__*/_jsx("td", {
                  children: c.job
                }), /*#__PURE__*/_jsx("td", {
                  children: c.mobile_first
                }), /*#__PURE__*/_jsx("td", {
                  children: c.company.label
                })]
              }, c.id);
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "DOSSIERS DE PLUS DE 6 JOURS AVEC CERTIFICATS INTROUVABLES"
      }),
      width: "90%",
      destroyOnClose: true,
      open: showLateFiles,
      onClose: function onClose() {
        setShowLateFiles(false);
      },
      children: /*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: lateRecords.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              })]
            }, c.id);
          })
        })]
      })
    })]
  });
};
export default Conclusion;